import React, { useEffect, useState, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { get, post, put } from './api';
import { t, LanguageSwitcher } from '@omnifuse/shared/frontend/i18n';
import { SettingsPanel } from '@omnifuse/shared/frontend/SettingsPanel';
import { get as apiGet, post as apiPost, put as apiPut } from './api';

const S = {
  page: { maxWidth: 1150, margin: '0 auto', padding: 24 } as React.CSSProperties,
  card: { background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,.08)', marginBottom: 16 } as React.CSSProperties,
  btn: { padding: '6px 14px', borderRadius: 8, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', fontSize: 13 } as React.CSSProperties,
  btnPrimary: { padding: '6px 14px', borderRadius: 8, border: 'none', background: '#1a73e8', color: '#fff', cursor: 'pointer', fontSize: 13 } as React.CSSProperties,
  table: { width: '100%', borderCollapse: 'collapse' as const, fontSize: 13 },
  th: { textAlign: 'left' as const, padding: '8px 10px', borderBottom: '2px solid #eee', color: '#555', whiteSpace: 'nowrap' as const },
  td: { padding: '8px 10px', borderBottom: '1px solid #f0f0f0' },
  tab: (a: boolean) => ({ padding: '8px 18px', cursor: 'pointer', borderBottom: a ? '2px solid #1a73e8' : '2px solid transparent', color: a ? '#1a73e8' : '#555', fontWeight: a ? 600 : 400, fontSize: 14 }) as React.CSSProperties,
  input: { padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc', fontSize: 13 } as React.CSSProperties,
};

const STAGES: Record<string, string> = {
  agreed: t('已达成'), sample_sent: t('已寄样'), content_posted: t('已发布'), completed: t('已完成'), cancelled: t('已取消'),
};

// ═══ 达人库 ═══
function CreatorsView() {
  const [rows, setRows] = useState<any[]>([]);
  const [form, setForm] = useState({ handle: '', platform: 'tiktok', followers: 0, engagement_rate: 0, niche: '', region: '' });
  const [msg, setMsg] = useState<any>(null);
  const [busy, setBusy] = useState('');

  const load = () => get('/api/v1/creators').then((r: any) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.handle) return alert('请填写达人账号');
    try { await post('/api/v1/creators', form); setForm({ ...form, handle: '', niche: '' }); load(); }
    catch (e: any) { alert(e.message); }
  };

  const evaluate = async (id: string) => {
    setBusy(id);
    try { const r: any = await post(`/api/v1/creators/${id}/evaluate`); alert(`匹配度 ${r.data.fit_score}/100\n${r.data.reason}`); load(); }
    catch (e: any) { alert(e.message); }
    setBusy('');
  };

  const outreach = async (id: string) => {
    setBusy(id);
    try { const r: any = await post(`/api/v1/creators/${id}/outreach`); setMsg(r.data); }
    catch (e: any) { alert(e.message); }
    setBusy('');
  };

  const startCollab = async (id: string) => {
    const products = prompt('寄样商品（描述）：');
    if (products === null) return;
    const code = prompt(t('专属折扣码（用于效果归因）：'), '');
    try { await post('/api/v1/collabs', { creator_id: id, sample_products: products, promo_code: code }); alert('合作已创建'); load(); }
    catch (e: any) { alert(e.message); }
  };

  return (
    <>
      <div style={S.card}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input style={{ ...S.input, width: 140 }} placeholder="@handle" value={form.handle} onChange={e => setForm({ ...form, handle: e.target.value })} />
          <select style={S.input} value={form.platform} onChange={e => setForm({ ...form, platform: e.target.value })}>
            <option value="tiktok">TikTok</option><option value="instagram">Instagram</option><option value="youtube">YouTube</option>
          </select>
          <input style={{ ...S.input, width: 110 }} type="number" placeholder={t('粉丝数')} value={form.followers || ''} onChange={e => setForm({ ...form, followers: Number(e.target.value) })} />
          <input style={{ ...S.input, width: 90 }} type="number" placeholder={t('互动率%')} value={form.engagement_rate || ''} onChange={e => setForm({ ...form, engagement_rate: Number(e.target.value) })} />
          <input style={{ ...S.input, width: 130 }} placeholder={t('垂类')} value={form.niche} onChange={e => setForm({ ...form, niche: e.target.value })} />
          <input style={{ ...S.input, width: 80 }} placeholder={t('地区')} value={form.region} onChange={e => setForm({ ...form, region: e.target.value })} />
          <button style={S.btnPrimary} onClick={add}>{t('＋ 添加达人')}</button>
        </div>
      </div>
      {msg && (
        <div style={{ ...S.card, background: '#f8f9fa' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <strong>外联消息草稿（第 {msg.round} 轮）</strong>
            <button style={S.btn} onClick={() => setMsg(null)}>{t('关闭')}</button>
          </div>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 13, background: '#fff', padding: 12, borderRadius: 8 }}>{msg.message}</pre>
          <button style={{ ...S.btnPrimary, marginTop: 8 }} onClick={async () => { await post(`/api/v1/outreach/${msg.id}/sent`); setMsg(null); load(); alert('已标记发送'); }}>
            ✓ 我已复制并发送
          </button>
        </div>
      )}
      <div style={S.card}>
        <table style={S.table}>
          <thead><tr>
            <th style={S.th}>{t('达人')}</th><th style={S.th}>{t('平台')}</th><th style={S.th}>{t('粉丝')}</th><th style={S.th}>{t('互动率')}</th>
            <th style={S.th}>{t('垂类')}</th><th style={S.th}>{t('匹配度')}</th><th style={S.th}>{t('状态')}</th><th style={S.th}>{t('操作')}</th>
          </tr></thead>
          <tbody>
            {rows.map((r: any) => (
              <tr key={r.id}>
                <td style={S.td}>@{r.handle}</td>
                <td style={S.td}>{r.platform}</td>
                <td style={S.td}>{r.followers >= 1000 ? `${(r.followers / 1000).toFixed(0)}k` : r.followers}</td>
                <td style={S.td}>{r.engagement_rate}%</td>
                <td style={S.td}>{r.niche || '-'}</td>
                <td style={{ ...S.td, fontWeight: 700, color: (r.fit_score ?? 0) >= 70 ? '#188038' : (r.fit_score ?? 0) >= 40 ? '#e8710a' : '#888' }}>
                  {r.fit_score !== null ? Math.round(r.fit_score) : '-'}
                </td>
                <td style={S.td}>{r.status}</td>
                <td style={{ ...S.td, whiteSpace: 'nowrap' }}>
                  <span style={{ display: 'inline-flex', gap: 6 }}>
                    <button style={S.btn} disabled={busy === r.id} onClick={() => evaluate(r.id)}>{t('评估')}</button>
                    <button style={S.btn} disabled={busy === r.id} onClick={() => outreach(r.id)}>{t('外联')}</button>
                    {r.status === 'replied' && <button style={S.btnPrimary} onClick={() => startCollab(r.id)}>{t('建合作')}</button>}
                  </span>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td style={S.td} colSpan={8}>{t('暂无达人 — 添加候选达人开始')}</td></tr>}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ═══ 外联记录 ═══
function OutreachView() {
  const [rows, setRows] = useState<any[]>([]);
  const load = () => get('/api/v1/outreach').then((r: any) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const reply = async (id: string) => {
    const text = prompt('粘贴达人回复内容：');
    if (text === null) return;
    try { await post(`/api/v1/outreach/${id}/reply`, { reply_text: text }); load(); } catch (e: any) { alert(e.message); }
  };

  return (
    <div style={S.card}>
      <table style={S.table}>
        <thead><tr><th style={S.th}>{t('达人')}</th><th style={S.th}>{t('轮次')}</th><th style={S.th}>{t('消息')}</th><th style={S.th}>{t('状态')}</th><th style={S.th}>{t('操作')}</th></tr></thead>
        <tbody>
          {rows.map((r: any) => (
            <tr key={r.id}>
              <td style={S.td}>@{r.handle}</td>
              <td style={S.td}>{r.round}</td>
              <td style={{ ...S.td, maxWidth: 360, fontSize: 12 }}>{(r.message || '').slice(0, 120)}...</td>
              <td style={S.td}>{r.status}</td>
              <td style={S.td}>
                {r.status === 'sent' && <button style={S.btn} onClick={() => reply(r.id)}>{t('记录回复')}</button>}
              </td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td style={S.td} colSpan={5}>{t('暂无外联记录')}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// ═══ 合作看板 ═══
function CollabsView() {
  const [rows, setRows] = useState<any[]>([]);
  const load = () => get('/api/v1/collabs').then((r: any) => setRows(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStage = async (id: string, stage: string) => {
    try { await put(`/api/v1/collabs/${id}`, { stage }); load(); } catch (e: any) { alert(e.message); }
  };

  const recordGmv = async (cl: any) => {
    const gmv = prompt(t('归因 GMV $？'), String(cl.gmv_attributed || 0));
    if (gmv === null) return;
    const orders = prompt(t('归因订单数？'), String(cl.orders_attributed || 0));
    try { await put(`/api/v1/collabs/${cl.id}`, { gmv_attributed: Number(gmv), orders_attributed: Number(orders || 0) }); load(); }
    catch (e: any) { alert(e.message); }
  };

  return (
    <div style={S.card}>
      <table style={S.table}>
        <thead><tr>
          <th style={S.th}>{t('达人')}</th><th style={S.th}>{t('阶段')}</th><th style={S.th}>{t('寄样')}</th><th style={S.th}>{t('发布链接')}</th>
          <th style={S.th}>{t('折扣码')}</th><th style={S.th}>{t('归因 GMV')}</th><th style={S.th}>{t('操作')}</th>
        </tr></thead>
        <tbody>
          {rows.map((r: any) => (
            <tr key={r.id}>
              <td style={S.td}>@{r.handle}（{(r.followers / 1000).toFixed(0)}k）</td>
              <td style={S.td}>
                <select style={S.input} value={r.stage} onChange={e => setStage(r.id, e.target.value)}>
                  {Object.entries(STAGES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </td>
              <td style={{ ...S.td, fontSize: 12 }}>{r.sample_products || '-'}</td>
              <td style={{ ...S.td, fontSize: 12, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {r.post_url ? <a href={r.post_url} target="_blank" rel="noreferrer">{r.post_url}</a> : '-'}
              </td>
              <td style={S.td}>{r.promo_code || '-'}</td>
              <td style={{ ...S.td, fontWeight: 700 }}>${(r.gmv_attributed || 0).toFixed(0)}（{r.orders_attributed} 单）</td>
              <td style={S.td}><button style={S.btn} onClick={() => recordGmv(r)}>{t('录入效果')}</button></td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td style={S.td} colSpan={7}>{t('暂无合作 — 在达人库中对已回复的达人"建合作"')}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

function App() {
  const [tab, setTab] = useState('creators');
  return (
    <div style={S.page}>
      <div style={{ position: 'fixed', top: 12, right: 16, zIndex: 1000 }}><LanguageSwitcher /></div>
      <h1 style={{ fontSize: 22, marginBottom: 4 }}>CreatorMatchAI</h1>
      <p style={{ color: '#666', marginBottom: 16 }}>{t('达人 UGC 匹配管理 — AI 匹配评估 · 自动外联 · 合作流看板')}</p>
      <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: 20 }}>
        <div style={S.tab(tab === 'creators')} onClick={() => setTab('creators')}>{t('达人库')}</div>
        <div style={S.tab(tab === 'outreach')} onClick={() => setTab('outreach')}>{t('外联记录')}</div>
        <div style={S.tab(tab === 'collabs')} onClick={() => setTab('collabs')}>{t('合作看板')}</div>
        <div style={S.tab(tab === 'settings')} onClick={() => setTab('settings')}>{t('设置')}</div>
      </div>
      {tab === 'creators' && <CreatorsView />}
      {tab === 'outreach' && <OutreachView />}
      {tab === 'collabs' && <CollabsView />}
      {tab === 'settings' && <SettingsPanel api={{ get: apiGet, post: apiPost, put: apiPut }} />}
    </div>
  );
}

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
